exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/contact/contact.component.css
// module id = ../../../../../src/app/components/contact/contact.component.css
// module chunks = main